import { ErrorResponse, ManualList, ManualRow } from "../../api";
import { manualSlice } from "../../features/Manual/store";
import { commonSlice, store } from "../../store";
import { api } from "../common/make_api";
import {
    ActionType,
    ResourceType,
    StatusType,
    sendLog,
} from "../common/send_log";

export async function getManuals(): Promise<void> {
    store.dispatch(commonSlice.actions.startLoading());

    try {
        const manualList: ManualList = await api.getManualAPI().getManuals();
        const markedManuals = (manualList.manuals as ManualRow[]).map(
            (note) => {
                return note;
            }
        );
        await store.dispatch(
            manualSlice.actions.updateManuals(markedManuals ?? [])
        );

        await sendLog(
            ResourceType.MANUAL,
            StatusType.GET_RESOURCE,
            ActionType.GET_MANUALS
        );
        return;
    } catch (err) {
        console.log("Got this error from manuals:", err);

        if (err.message) {
            store.dispatch(
                commonSlice.actions.setErrorMessage([err.message as string])
            );
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }
        if (err.status && err.status == 500) {
            await store.dispatch(commonSlice.actions.showServerErrorMessage());
            return;
        }

        const res = (await (err as Response).json()) as ErrorResponse;

        if (err["status"] == 401) {
            console.log("Console is reloading...", res);
            return;
        }
        store.dispatch(commonSlice.actions.setErrorMessage([res.message!]));
        return;
    } finally {
        store.dispatch(commonSlice.actions.finishLoading());
    }
}
